var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";
import classnames from "classnames";
import "keyrune/sass/keyrune.scss";
import keyrune from "./keyrune.scss";

var rawRarities = keyrune.rarities,
    setlist = _objectWithoutProperties(keyrune, ["rarities"]);

export var sizes = ["2x", "3x", "4x", "5x", "6x"];
export var sets = Object.entries(setlist).reduce(function (hash, _ref) {
  var key = _ref[0],
      value = _ref[1];
  hash[key] = value.replace(/"+/g, "");
  return hash;
}, {});
export var rarities = rawRarities.replace(/"+/g, "").split(" ");
var raritiesMap = new Map([].concat(rarities.map(function (rarity) {
  return [rarity, rarity];
}), rarities.map(function (rarity) {
  return [rarity.charAt(0), rarity];
})));

var Keyrune = function Keyrune(_ref2) {
  var _classnames;

  var set = _ref2.set,
      size = _ref2.size,
      _ref2$fixed = _ref2.fixed,
      fixed = _ref2$fixed === undefined ? false : _ref2$fixed,
      rarity = _ref2.rarity,
      _ref2$gradient = _ref2.gradient,
      gradient = _ref2$gradient === undefined ? false : _ref2$gradient,
      _ref2$foil = _ref2.foil,
      foil = _ref2$foil === undefined ? false : _ref2$foil,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["set", "size", "fixed", "rarity", "gradient", "foil", "className"]);

  return React.createElement("i", _extends({
    title: sets[set],
    alt: sets[set],
    className: classnames(className, (_classnames = {
      "ss": true
    }, _classnames["ss-" + set] = Object.keys(sets).includes(set), _classnames["ss-" + size] = sizes.includes(size), _classnames["ss-fw"] = fixed, _classnames["ss-" + raritiesMap.get(rarity)] = raritiesMap.has(rarity), _classnames["ss-grad"] = gradient || foil, _classnames["ss-foil"] = foil, _classnames)),
    "aria-hidden": true
  }, props));
};

export { Keyrune };